//import "./App.css";
import "./index.css";

import Table from "./components/Table";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>TCF / CRA Data Search</h1>
        <Table />
      </header>
    </div>
  );
}

export default App;
